import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'sc-camera-info-menu',
  templateUrl: './camera-info-menu.component.html',
  styleUrls: ['./camera-info-menu.component.scss'],
})
export class CameraInfoMenuComponent implements OnInit {
  osSecurityPreferences: string;

  constructor(private deviceDetectorService: DeviceDetectorService) {}

  ngOnInit() {
    this.setupOS();
  }

  setupOS() {
    const deviceInfo = this.deviceDetectorService.getDeviceInfo();

    if (deviceInfo.os === 'Mac') {
      this.osSecurityPreferences =
        'Allow OS permission within Apple / System Preferences / Security & Privacy / Camera & check the box next to your Browser';
    } else if (deviceInfo.os === 'Windows') {
      this.osSecurityPreferences =
        'Allow OS permission within Start / Settings > Privacy / Camera & select On next to Allow apps to access your Camera';
    }
  }
}
